<div class="admin-page">
  <div class="container">

    <h2>User Management</h2>

    <!-- Top Bar -->
    <div class="top-bar">
      <input type="text" class="search-box" placeholder="Search users by name or email..." [value]="searchTerm" (input)="onSearch($any($event.target).value)">
        <div class="actions">
            <button class="btn primary" (click)="openAddModal()">+ Add User</button>
        </div>
    </div>

    <!-- User Table -->
    <div class="table-wrapper">
      <ze-loader *ngIf="isLoading"></ze-loader>
      <div *ngIf="!isLoading">
        <table>
            <thead>
                <tr>
                  <th class="col-user">User</th>
                  <th class="col-email">Username</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
            </thead>

            <tbody>
                
                  <tr *ngFor="let user of filteredUsers">
                    <td class="user-cell col-user">
                      <div class="name">{{ user.name }}</div>
                      <div class="muted id">ID: {{ user.userId ? user.userId.slice(-5) : 'N/A' }}</div>
                    </td>
                    <td class="col-email">{{ user.userName || '-' }}</td>
                    <td>
                      <span class="status" [ngClass]="!user.disabled ? 'active' : 'inactive'">{{ !user.disabled ? 'Active' : 'Disabled' }}</span>
                    </td>
                    <td class="actions-cell">
                      <div class="action">
                      <!-- <button class="btn small edit" (click)="openEditModal(user)">Edit</button>
                      <button class="btn small delete" (click)="deleteUser(user)">Delete</button> -->
                      <label class="switch" title="Toggle active">
                        <input type="checkbox" [checked]="!user.disabled" (change)="toggleActive(user, $any($event.target).checked)" [disabled]="user._updating">
                        <span class="slider"></span>
                      </label>
                      </div>
                    </td>
                    </tr>
                  <tr *ngIf="filteredUsers.length === 0">
                    <td colspan="4" class="empty">No users found for "{{ searchTerm }}"</td>
                  </tr>
            </tbody>

        </table>
              </div>
    </div>

    <!-- Pagination -->
    <div class="pagination" *ngIf="totalCount > pageSize">
      <button class="btn" (click)="prev()" [disabled]="currentStartIndex===0">Prev</button>
      <div class="muted" style="padding:6px 10px">Page {{ currentPageNumber }} of {{ totalPagesNumber }}</div>
      <button class="btn" (click)="next()" [disabled]="!hasNext">Next</button>
    </div>

</div>
</div>

<!-- Modal popup for Add / Edit -->
<div class="modal-backdrop" *ngIf="modalOpen">
  <div class="modal">
    <h3>{{ editingUser && editingUser.userId ? 'Edit User' : 'Add User' }}</h3>
    <div class="modal-body">
      <label>First Name</label>
      <input type="text" [value]="editingUser.firstName" (input)="editingUser.firstName = $any($event.target).value">
      <span class="error-text" *ngIf="validationErrors['firstName']">{{ validationErrors['firstName'] }}</span>

      <label>Last Name</label>
      <input type="text" [value]="editingUser.lastName" (input)="editingUser.lastName = $any($event.target).value">
      <span class="error-text" *ngIf="validationErrors['lastName']">{{ validationErrors['lastName'] }}</span>

      <label>Email</label>
      <input type="email" [value]="editingUser.emailID" (input)="editingUser.emailID = $any($event.target).value">
      <span class="error-text" *ngIf="validationErrors['emailID']">{{ validationErrors['emailID'] }}</span>

      <label>Mobile</label>
      <input type="text" [value]="editingUser.contactNo" (input)="editingUser.contactNo = $any($event.target).value">
      <span class="error-text" *ngIf="validationErrors['contactNo']">{{ validationErrors['contactNo'] }}</span>

      <label>Designation</label>
      <input type="text" [value]="editingUser.designation" (input)="editingUser.designation = $any($event.target).value">

      <label>Active</label>
      <label class="switch small">
        <input type="checkbox" [checked]="!editingUser.disabled" (change)="editingUser.disabled = !$any($event.target).checked">
        <span class="slider"></span>
      </label>
    </div>
    <div class="modal-actions">
      <button class="btn" (click)="closeModal()">Cancel</button>
      <button class="btn primary" (click)="saveUser()" [disabled]="isSavingUser">
        <span *ngIf="!isSavingUser">Save</span>
        <span *ngIf="isSavingUser">Saving...</span>
      </button>
    </div>
    <div class="modal-feedback" *ngIf="userCreationMessage">
      <div [ngClass]="{'success': userCreationSuccess, 'error': !userCreationSuccess}" class="message">{{ userCreationMessage }}</div>
    </div>
  </div>
</div>